import { ComponentCommunicationService } from 'src/app/component-communication.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EnumConverterService } from 'src/app/services/EnumConverterService';
import { GenderEnum } from 'src/app/model/enums/GenderEnum';
import { ApplicationApiService } from 'src/app/services/applicationApiService';
import { BaseOption } from 'src/app/model/BaseOption';
import { TranslateService } from '@ngx-translate/core';
import { LocationDto } from '../../model/LocationDto';
import { Constants } from 'src/app/constants';
import { ConfigSettingDto } from '../../model/business/ConfigSettingDto';
import { SessionService } from '../../session-service.service';
import { FontTypeEnum } from '../../model/enums/FontTypeEnum';

@Component({
  selector: 'app-application-insured',
  templateUrl: './application-insured.component.html',
  styleUrls: ['./application-insured.component.css'],
})
export class ApplicationInsuredComponent implements OnInit {
  @Input()
  insuredFormGroup: FormGroup;

  genderList = this.enumConverterService.toBaseList('GenderEnum', GenderEnum);
  countryList: BaseOption[];
  phonePattern = Constants.phonePattern;
  phoneMask = Constants.phoneInputMask;
  ibanMask = Constants.ibanInputMask;
  isZipCodeLoaderShown = false;
  isEmptyZipCodeServiceResultMessageShown = false;
  FontTypeEnum = FontTypeEnum;

  constructor(
    private enumConverterService: EnumConverterService,
    private applicationApiService: ApplicationApiService,
    private translateService: TranslateService,
    private componentCommunicationService: ComponentCommunicationService,
    private sessionService: SessionService,
  ) {}

  ngOnInit(): void {
    this.applicationApiService
      .getCountries()
      .subscribe((countries: string[]) => {
        const baseOptions: BaseOption[] = [];
        countries.forEach((countryCode: string) => {
          const translatedValue = this.translateService.instant(
            `CountryFromCode.${countryCode}`
          );
          baseOptions.push(new BaseOption(countryCode, translatedValue.trim()));
        });
        this.countryList = baseOptions;
      });

    this.insuredFormGroup.get('houseNumber').valueChanges.subscribe(newValue => {
      this.updateStreetAndCity(this.insuredFormGroup.controls.zipCode.value, newValue);
    });

    this.insuredFormGroup.get('zipCode').valueChanges.subscribe(newValue => {
      this.updateStreetAndCity(newValue, this.insuredFormGroup.controls.houseNumber.value);
    });
  }

  get dateMaskFormat(): string {
    return this.componentCommunicationService.getDateFormat();
  }

  setIsZipCodeLoaderShown(isZipCodeLoaderShown: boolean): void {
    this.isZipCodeLoaderShown = isZipCodeLoaderShown;
  }

  setIsEmptyZipCodeServiceResultMessageShown(isEmptyZipCodeServiceResultMessageShown: boolean): void {
    this.isEmptyZipCodeServiceResultMessageShown = isEmptyZipCodeServiceResultMessageShown;
  }

  updateStreetAndCity(zipCode: string, houseNo: string): void {
    if (!zipCode || zipCode === '') {
      return;
    }

    if (!houseNo || houseNo === '') {
      return;
    }

    this.setIsZipCodeLoaderShown(true);

    this.applicationApiService.getLocation(zipCode, houseNo).subscribe((location: LocationDto) => {
      this.setIsZipCodeLoaderShown(false);

      if (!location.city) {
        this.setIsEmptyZipCodeServiceResultMessageShown(true);
        return;
      }

      this.setIsEmptyZipCodeServiceResultMessageShown(false);

      if (location.city) {
        this.insuredFormGroup.get('city').patchValue(location.city);
      }

      if (location.street) {
        this.insuredFormGroup.get('street').patchValue(location.street);
      }
    });
  }

  get configSettings(): ConfigSettingDto {
    return this.sessionService.getConfigSettingsDto();
  }
}
